/**
 * @desc 根据id删除部门
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type DeleteDeptParameter = {
  id?: string
}

const method = 'DELETE'
const url = '/auth/dept'

export const deleteDeptApi = (
  params?: DeleteDeptParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

deleteDeptApi.method = method
deleteDeptApi.url = url
